import type { TenantName } from '@root/@types/types';

import type {
  BrandingAJG,
  BrandingArtificial,
  BrandingBMS,
  BrandingHowden,
  BrandingLockton,
  BrandingMcGill,
} from './types';

const client: TenantName = import.meta.env?.VITE_CLIENT ?? process?.env?.CLIENT;

const getPdfBrandingAJG = () => {
  return [
    'Gallagher',
    'Gallagher European Risk Services',
    'Gallagher Retail',
    'Alesco',
    'Alesco Europe',
  ] satisfies BrandingAJG[];
};

const getPdfBrandingBMS = () => {
  return [
    'BMS',
    'BMS Bermuda',
    'BMS Re',
    'BMS Re Asia',
    'BMS Re Australia',
    'BankServe',
    'H&D Marine',
  ] satisfies BrandingBMS[];
};

const getPdfBrandingHowden = () => {
  return ['Howden'] satisfies BrandingHowden[];
};

const getPdfBrandingLockton = () => {
  return ['Lockton', 'Lockton Edge', 'Lockton Omni', 'Lockton SBS', 'Lockton FAC'] satisfies BrandingLockton[];
};

const getPdfBrandingMcGill = () => {
  return ['McGill'] satisfies BrandingMcGill[];
};

const getPdfBrandingArtificial = () => {
  return ['Artificial', 'Artificial Brand 2'] satisfies BrandingArtificial[];
};

export const getPdfBrandingList = (): string[] =>
  client === 'ct-ajg'
    ? getPdfBrandingAJG()
    : client === 'ct-bms'
      ? getPdfBrandingBMS()
      : client === 'ct-howden'
        ? getPdfBrandingHowden()
        : client === 'ct-lockton'
          ? getPdfBrandingLockton()
          : client === 'ct-mcgill'
            ? getPdfBrandingMcGill()
            : getPdfBrandingArtificial();
